import { useGLTF } from '@react-three/drei';

function Backgroud(props) {
  const { bgFile } = props;
  const { scene } = useGLTF(bgFile, '/draco/gltf/')
  return <primitive object={scene} />;
}

export default Backgroud;
